// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { ActionOut } from './actionOut.zod.ts';

export const EntityOut = zod.object({
  "actions": zod.array(ActionOut),
  "name": zod.string()
});

export type EntityOut = zod.input<typeof EntityOut>;
export type EntityOutOutput = zod.output<typeof EntityOut>;
